import { Link } from 'react-router-dom'

import { Button, Divider, Trans } from '@/components'
import { InstanceListView } from '@/components/InstanceListView'
import { TeamRole } from '@/consts/team'
import { InstanceContextOverride } from '@/contexts/InstanceContext'
import { useInstanceList } from '@/hooks/useInstanceList.tsx'
import { useStorageBillingMode } from '@/hooks/useStorageBillingMode'
import { InstanceDetail } from '@/pages/instance-list/components/InstanceDetail'
import { useTeamStore } from '@/stores/team'

import { ViewSwitcher } from '../components/ViewSwitcher'

export function MemberInstanceView() {
  const instanceListState = useInstanceList()
  const teamStore = useTeamStore()

  const { snapshotOnSpaceBilling } = useStorageBillingMode()

  // Get current user role from team token data
  const userRole = teamStore.teamTokenData?.userRole

  // Check if user is Owner or Admin
  const isAdminOrOwner = userRole === TeamRole.Owner || userRole === TeamRole.Admin

  return (
    <div className="card bg-panel-white h-full overflow-y-auto">
      {/* Unified header section */}
      <div className="flex h-[60px] items-center justify-between">
        <div className="flex gap-2 items-center">
          <div className="h6">
            <Trans i18nKey="instance.title">My Instances</Trans>
          </div>
          {/* Only show ViewSwitcher for Owner/Admin */}
          {isAdminOrOwner && <ViewSwitcher />}
        </div>
        {/* Create New button always visible in Member View */}
        <Link to="/team/create">
          <Button type="secondary">
            <Trans i18nKey="instance.createBtn">Create New</Trans>
          </Button>
        </Link>
      </div>

      <Divider />

      {/* Member View: Show user's own instances using Platform APIs
          Override context to 'platform' mode so that InstanceDetail's child components
          (InstanceBilling, InstanceHardware) call platform APIs instead of team admin APIs.
          This allows regular team members to view their own instance details without
          requiring admin permissions. */}
      <InstanceContextOverride mode="platform">
        <InstanceListView
          {...instanceListState}
          hideHeader={true}
          snapshotOnSpaceBilling={snapshotOnSpaceBilling}
          DetailComponent={InstanceDetail}
          detailComponentProps={{
            readOnly: false,
          }}
        />
      </InstanceContextOverride>
    </div>
  )
}
